// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faqs__title[data-v-72b4511c]{margin-bottom:1.5rem;text-align:center}@media (min-width: 1024px){.faqs__title[data-v-72b4511c]{margin-bottom:2rem}}.faqs__show-more[data-v-72b4511c]{margin-top:1.5rem}@media (min-width: 1024px){.faqs__show-more[data-v-72b4511c]{margin-top:2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
